import { render, staticRenderFns } from "./IconMercadopago.vue?vue&type=template&id=0d9f3f87&scoped=true"
var script = {}
import style0 from "./IconMercadopago.vue?vue&type=style&index=0&id=0d9f3f87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9f3f87",
  null
  
)

export default component.exports